import { HorizontalContainer } from '@american-autonomy/ag-ui';

import DroneHealthChart from 'components/DroneHealthChart';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HealthCharts: FunctionComponent<Props> = ({ className = '', items, testId = TEST_ID }) => {
    const translations = useTranslation();

    return (
        <HorizontalContainer className={`${className} ${styles.healthCharts}`} testId={testId}>
            {items.map(item => (
                <DroneHealthChart
                    className={styles.healthChart}
                    key={item.text}
                    text={translations[item.text]}
                    value={item.value}
                />
            ))}
        </HorizontalContainer>
    );
};

export default HealthCharts;
